import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import ModulesNavigation from "../../sub-header";
import ExpenseTypePopup from "./add-popup";
import DeleteModal from "@common/popup/DeleteModal";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { QueryRequestHelper } from "@common/query-request-helper";
import { toast } from "react-toastify";
import SearchHeader from "@components/common/SearchHeader";
import GearLoader from "@components/common/GearLoader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import ExpenseActiveCategoryTable from "./table";
import {
  createExpenseCategory,
  deleteExpenseCategory,
  getAllExpenseCategories,
  getSpecificExpenseCategory,
  updateExpenseCategory,
  updateExpenseCategoryBulk,
} from "@services/expense-category.service";
import ExpenseActiveCategoryPopup from "./add-popup";
import NavigationBar from "@components/NotificationBar";
import NoAccessPage from "@components/common/NoAccess";
import SkeletonTable from "@components/common/Skeleton/skeleton-table";

function AdminExpenseActiveCategory(props: any) {
  const navigate = useNavigate();
  const params = useParams();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  /* -------------------------------------------------------------------------- */
  /*                               UseState section                             */
  /* -------------------------------------------------------------------------- */

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                                 API section                                */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    try {
      let payload = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getAllExpenseCategories(queryRequest);
      if (resp) {
        setList(getValue(resp, `data.data`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    let payload: any = {
      ...urlParams,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteEntity = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await deleteExpenseCategory(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIDs, setSelectedIDs] = useState<any>([]);

  const handleCheckUsers = (id: string) => {
    let userIDs =
      getValue(selectedIDs, `length`, 0) > 0
        ? selectedIDs.map((item: string) => item)
        : [];
    if (userIDs.includes(id)) {
      let filterIDs = selectedIDs.filter((item: string) => item !== id);
      setSelectedIDs(filterIDs);
    } else {
      selectedIDs.push(id);
      setSelectedIDs([...selectedIDs]);
    }
  };
  const handleCheckAll = (status: string) => {
    if (status === "All") {
      setSelectedIDs([]);
    } else {
      let userIDs =
        getValue(list, `length`, 0) > 0
          ? list.map((item: object) => getValue(item, `id`, ""))
          : [];
      setSelectedIDs(userIDs);
    }
  };
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await updateExpenseCategoryBulk({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const handleNavigateUserEntity = () => {
    if (getValue(selectedIDs, `[${0}]`, "")) {
      // navigate(
      //   `/admin/user/entity-mapping/${getValue(selectedIDs, `[${0}]`, "")}`
      // );
    } else {
      toast.error("Please select Email Template");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Edit section                             */
  /* -------------------------------------------------------------------------- */

  const [editId, setEditId] = useState("");
  const handleEditEntity = async (id: string) => {
    setEditId(id);
    try {
      let resp = await getSpecificExpenseCategory(id);
      if (resp) {
        setRequest({
          ...request,
          category_name: getValue(resp, `data.category_name`, ""),
          category_code: getValue(resp, `data.category_code`, ""),
          description: getValue(resp, `data.description`, ""),
          isCreditAccount: getValue(resp, `data.isCreditAccount`, false),
        });
        setShowUpdatePopup(true);
      }
    } catch (error) {}
  };

  /* ---------------------------  Insert Modal  ----------------------------- */

  const intialData = {
    category_name: "",
    category_code: "",
    description: "",
    isCreditAccount: false,
  };
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const handlePopup = () => {
    setShowUpdatePopup(!showUpdatePopup);
    setRequest({
      ...intialData,
    });
  };
  const [request, setRequest] = useState({
    ...intialData,
  });
  const handleChangeText = (e: any) => {
    const { name, value, type, checked } = e.target;
    setRequest({
      ...request,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleReset = () => {
    setRequest({
      ...intialData,
    });
    setEditId("");
  };

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      let payload: any = request;
      Object.keys(payload).forEach((key) => {
        if (
          payload[key] === "" ||
          payload[key] === null ||
          payload[key] === undefined
        ) {
          delete payload[key];
        }
      });
      setSubmitLoading(true);
      if (editId) {
        let resp = await updateExpenseCategory(editId, payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          setShowUpdatePopup(false);
          getData();
          handleReset();
        } else {
          setSubmitLoading(false);
        }
      } else {
        let resp = await createExpenseCategory(payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          setShowUpdatePopup(false);
          getData();
          handleReset();
        } else {
          setSubmitLoading(false);
        }
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };
  const dropdownOptions = [
    { label: "Expense Category", value: "EXPENSE_CATEGORY" },
  ];

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "admin_modules_expenses"
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <GearLoader />
      ) : (
        <>
          <ModulesNavigation
            headerTitle={"Fields"}
            name={`expenses`}
            hideSubmit
            permissions={getValue(props, `permissions`, [])}
          />
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              // isMarkInactiveSectionVisible={true}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              handleRemoveNavItems={handleRemoveNavItems}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              permissions={getValue(props, `permissions`, [])}
              entityMapping={
                getValue(props, `products`, []).includes("SELFCOMP")
                  ? true
                  : false
              }
              handleNavigateUserEntity={handleNavigateUserEntity}
            />
          )}
          <div className="admin-wrapper position-relative">
            <div className="admin-wrapper position-relative">
              <SearchHeader
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                isAdd={
                  getValue(props, `permissions`, []).includes("create")
                    ? true
                    : false
                }
                add={
                  getValue(props, `permissions`, []).includes("create")
                    ? "true"
                    : "false"
                }
                handleAddFun={() => handlePopup()}
                commonUpload={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                download={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                download_type={"EXPENSE_CATEGORY"}
                // log_name={"USER"}
                // logs
                dropdownOptions={dropdownOptions}
                downloadURL={
                  "https://tripex-data.s3.ap-south-1.amazonaws.com/system/Tripex-Expense_Category_Import_Template.xlsx"
                }
              />
            </div>
          </div>
          <div
            className={
              getValue(selectedIDs, `length`, 0) > 0
                ? "datatable_main_container_notifiction"
                : "datatable_main_container"
            }
            style={{ overflowY: isLoading ? "hidden" : "auto" }}
          >
            {isLoading || !props.permissionAPITriggered ? (
              // <GearLoader />
              <SkeletonTable />
            ) : getValue(list, `length`, 0) > 0 ? (
              <>
                <ExpenseActiveCategoryTable
                  list={list}
                  selectedIDs={selectedIDs}
                  handleCheckUsers={handleCheckUsers}
                  handleCheckAll={handleCheckAll}
                  handleEditEntity={handleEditEntity}
                  permissions={getValue(props, `permissions`, [])}
                />
              </>
            ) : (
              <>
                {Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
              </>
            )}
          </div>
          <div className="fixed_footer_wrapper d-flex justify-content-between">
            {list.length > 0 && (
              <img
                src="/images/building-illustration.svg"
                className="img-fluid"
              />
            )}
            {totalCount > 10 ? (
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
              />
            ) : (
              <p className="show-rows-count mt-3 d-flex">
                Total Count:&nbsp;&nbsp;{" "}
                <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
              </p>
            )}
          </div>
          <ExpenseActiveCategoryPopup
            showUpdatePopup={showUpdatePopup}
            setShowUpdatePopup={setShowUpdatePopup}
            request={request}
            handleChangeText={handleChangeText}
            handleSubmit={handleSubmit}
            submitLoading={submitLoading}
            editId={editId}
            setRequest={setRequest}
            handleReset={handleReset}
          />
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
    </DashboardLayout>
  );
}

export default AdminExpenseActiveCategory;
